import type { HelpRequest } from '../api/generated/HelpRequest'
import type { HelpResponder } from '../api/generated/HelpResponder'

const nameOf = (who: { name?: string | null; from_organizer: boolean }) =>
  who.name ?? (who.from_organizer ? 'Un organisateur' : 'Un bénévole')

/** `Bob · Accueil, Entrée`: who asks, and where for a volunteer. */
export function requestWho(request: HelpRequest): string {
  const place = [request.position_name, request.location].filter(Boolean).join(', ')
  const who = nameOf({ name: request.requester_name, from_organizer: request.from_organizer })
  return place ? `${who} · ${place}` : who
}

/** `Ann et Paul arrivent`, or undefined when nobody answered yet. */
export function respondersLine(responders: HelpResponder[]): string | undefined {
  const names = responders.map(nameOf)
  if (names.length === 0) return undefined
  if (names.length === 1) return `${names[0]} arrive`
  return `${names.slice(0, -1).join(', ')} et ${names.at(-1)} arrivent`
}
